import "./EditForm/PasswordEditComponent";

import "./ProfilePassword.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ProfilePasswordComponentController from "./ProfilePasswordComponentController";

export default class ProfilePasswordComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            profile: "<",
        };
        this.controller = ProfilePasswordComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/Profile/Password/ProfilePassword.html";
    }
}

module("mmAuth").component("mmProfilePassword", new ProfilePasswordComponent());
